import { useEffect } from 'react'
import { TFunction, i18n } from 'i18next'
import { Formik } from 'formik'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { DocumentTitle } from '@dhl/receiver-a11y'
import { UpdatePackageOptions, updatePackage } from '~/basket/model/session/actions'
import { InjectedBasketProps, withBasket } from '~/basket/view/withBasket'
import { PackageForm, createPackageValidationSchema } from './PackageForm'

import { STEP_NAME } from '~/basket/model/constants'
import { Package } from '~/basket/model/session/reducers'
import { ShipmentTemplate } from '~/basket/view/components/ShipmentTemplate'
import { scrollToTop } from '~/basket/view/util/layout'

type Props = InjectedBasketProps & {
  updatePackage: (values: Partial<Package>, options: UpdatePackageOptions) => void
  t: TFunction
  // eslint-disable-next-line react/no-unused-prop-types
  i18n: i18n
}

// eslint-disable-next-line @typescript-eslint/no-shadow
const PackagePageComponent = ({ basket, stepNavigation, isLoadingBasket, updatePackage, t }: Props) => {
  useEffect(() => {
    scrollToTop()
  }, [])

  const validationSchema = createPackageValidationSchema({
    isTrackerCodeRequired: basket.config.isTrackerCodeEnabled,
  })(t)

  const onSubmit = (values: Package) => {
    updatePackage(values, {})
    stepNavigation.goToNextStep()
  }

  const goToPreviousStep = (values: Package) => {
    updatePackage(values, {})
    stepNavigation.goToPreviousStep()
  }

  const initialValues = {
    ...basket.package,
    trackerCodeInputMode: 'manual',
  }

  return (
    <>
      <DocumentTitle title={t('package')} />

      <Formik
        validateOnBlur
        initialValues={initialValues}
        onSubmit={onSubmit}
        validateOnChange={false}
        validationSchema={validationSchema}
      >
        {({ submitForm, values }) => (
          <ShipmentTemplate
            basket={basket}
            stepNavigation={{
              ...stepNavigation,
              goToNextStep: submitForm,
              goToPreviousStep: () => goToPreviousStep(values),
            }}
            isLoadingBasket={isLoadingBasket}
            testId="package-page"
            showNavigation
          >
            <PackageForm basket={basket} isLoading={isLoadingBasket} updatePackage={updatePackage} />
          </ShipmentTemplate>
        )}
      </Formik>
    </>
  )
}

const mapDispatchToProps = {
  updatePackage,
}

export const PackagePage = withBasket(
  connect(null, mapDispatchToProps)(withTranslation()(PackagePageComponent)),
  STEP_NAME.PACKAGE
)
